import http from 'api/httpClient';

export type OuAnalysisRequest = {
  year: string;
  months?: number[];
  selection?: Record<string, string[]>;
  filters?: Record<string, string[]>;
};

export type OuMetricsData = {
  ous: number;
  income: number;
  expenses: number;
  cm: number;
  cm_pct: string;
};

export type OuBucketData = {
  title: string;
  order: number;
  min_pct: number | null;
  max_pct: number | null;
  min_inclusive: boolean;
  max_inclusive: boolean;
  metrics: OuMetricsData;
};

export type OuAnalysisResponse = {
  cards: {
    total: {
      title: string;
      metrics: OuMetricsData;
    };
    buckets: OuBucketData[];
  };
};

export interface OuTableRow {
  ou_code: string;
  ou_name: string;
  income: number;
  expenses: number;
  cm: number;
  cm_pct: number;
}

export interface OuTableResponse {
  total: number;
  items: OuTableRow[];
}

export interface OuDrilldownRequest extends Record<string, unknown> {
  year: string;
  months?: number[];
  selection?: Record<string, string[]>;
  filters?: Record<string, string[]>;
  bucket: {
    min_pct: number | null;
    max_pct: number | null;
    min_inclusive: boolean;
    max_inclusive: boolean;
  };
  sort: {
    by: 'income' | 'expenses' | 'cm' | 'cm_pct' | 'ou_name' | 'ou_code';
    dir: 'asc' | 'desc';
  };
  page: number;
  page_size: number;
}

export async function fetchOuAnalysisStats(payload: OuAnalysisRequest): Promise<OuAnalysisResponse> {
  return http.post('/api/v1/dashboard/ou-analysis/stats', payload);
}

export async function fetchOuDrilldown(
  params: OuDrilldownRequest
): Promise<OuTableResponse> {
  return http.post('/api/v1/dashboard/ou-analysis/ous', params);
}
